import { Subscription } from 'rxjs';
// Subscriptionをメソッドチェインで指定Subscriptionにaddする
Subscription.prototype.addTo = function (collectorSub) {
    collectorSub.add(this);
};
export { Subscription };
